import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import { defineModule } from '@/app/router/defineModule.ts';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'zones',
    routes: [
        {
            path: '/zones',
            name: 'zones',
            component: () => import('#modules/zones/pages/index.vue'),
            meta: {
                layout: 'app',
                permissions: [AppPermissions.ManageZones],
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
        },
        {
            path: '/zones/:zone/dns',
            name: 'zone dns',
            component: () => import('#modules/zones/pages/dns.vue'),
            meta: {
                layout: 'app',
                permissions: [AppPermissions.ManageZones],
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
        },
    ],
});
